import React from "react";
import NewOrderForm from "./NewOrderForm";

export default function Index(props) {
  return <NewOrderForm {...props} />;
}
